import CardWithTitle from 'components/CardWithTitle';
import React, { useContext, useEffect } from 'react';
import { axiosUpdate } from 'services';
import { toast } from 'react-toastify';
import { authContext } from 'contexts/AuthContext';
import { Row } from 'reactstrap';
import AlertV2 from 'components/common/AlertV2';
import CommissionForm from './CommissionForm';

const CommissionSection = ({ values, handleChange, setFieldValue }) => {
  const { auth } = useContext(authContext);

  useEffect(() => {
    if (
      values?.sellerCommissionJson?.ShouldExcludeCumulativeQuantityForThatMonth
    ) {
      setFieldValue(
        'excludeCumulativeQuantityForThatMonth',
        values?.sellerCommissionJson
          ?.ShouldExcludeCumulativeQuantityForThatMonth,
      );
    }
  }, [
    values?.sellerCommissionJson?.ShouldExcludeCumulativeQuantityForThatMonth,
  ]);

  useEffect(() => {
    if (values?.sellerCommissionJson?.DiscountAmount) {
      setFieldValue(
        'sellerDiscountAmount',
        values?.sellerCommissionJson?.DiscountAmount,
      );
    }

    if (values?.buyerCommissionJson?.DiscountAmount) {
      setFieldValue(
        'buyerDiscountAmount',
        values?.sellerCommissionJson?.DiscountAmount,
      );
    }
  }, [
    values?.sellerCommissionJson?.DiscountAmount,
    values?.buyerCommissionJson?.DiscountAmount,
  ]);

  const onUpdateCommissionDiscount = async () => {
    try {
      const buyerPayload = {
        orderId: values?.id,
        discountAmount: values?.buyerDiscountAmount,
        excludeCumulativeQuantityForThatMonth:
          values?.excludeCumulativeQuantityForThatMonth,
        isSellerCommissionDiscount: false,
      };

      const sellerPayload = {
        orderId: values?.id,
        discountAmount: values?.sellerDiscountAmount,
        excludeCumulativeQuantityForThatMonth:
          values?.excludeCumulativeQuantityForThatMonth,
        isSellerCommissionDiscount: true,
      };
      let showToast = true;
      if (
        !(
          values?.buyerCommissionAmount === 0 ||
          values?.buyerCommissionAmount === null ||
          values?.buyerCommissionAmount === undefined
        )
      ) {
        const buyerResp = await axiosUpdate(
          `${process.env.REACT_APP_REST_API_ENDPOINT}commission/give-discount-on-commission`,
          buyerPayload,
          auth?.data?.token,
        );
        if (!buyerResp?.isSuccessful && buyerResp?.data?.message) {
          showToast = false;
          toast.error(buyerResp?.data?.message);
        }
      }

      const sellerResp = await axiosUpdate(
        `${process.env.REACT_APP_REST_API_ENDPOINT}commission/give-discount-on-commission`,
        sellerPayload,
        auth?.data?.token,
      );

      if (showToast && sellerResp?.isSuccessful) {
        toast.success('Discount Amount Updated successfully');
      }

      if (!sellerResp?.isSuccessful && sellerResp?.data?.message) {
        toast.error(sellerResp?.data?.message);
      }
    } catch (error) {
      console.error('error while updating the discount price');
    }
  };

  const format = (value) => {
    return value?.toLocaleString('en-IN');
  };

  return (
    <CardWithTitle>
      <div
        className="order-commission__header"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginTop: '20px',
          marginBottom: '20px',
        }}
      >
        <h4 className="f-16 fw-semibold" style={{ marginBottom: 0 }}>
          Commission
        </h4>
        <p key="info" style={{ color: '#BB3232' }}>
          For Seller: {values?.rateUnit?.label}{' '}
          {format(
            values?.sellerCommissionJson?.CommissionWithoutDiscount
              ? (values?.sellerCommissionJson?.CommissionWithoutDiscount || 0) -
                  (values.sellerDiscountAmount || 0)
              : 0,
          )}
          , Final For Buyer: {values.rateUnit.label}{' '}
          {format(
            values?.buyerCommissionJson?.CommissionWithoutDiscount
              ? (values?.buyerCommissionJson?.CommissionWithoutDiscount || 0) -
                  (values.buyerDiscountAmount || 0)
              : 0,
          )}
        </p>
      </div>

      <CommissionForm
        values={values}
        handleChange={handleChange}
        setFieldValue={setFieldValue}
        onSaveCommission={onUpdateCommissionDiscount}
      />

      {/* <Row>
            <AlertV2 style={{marginTop: '10px'}} color="warning" title="Note:">
              Commissions are set from global values. After adding a discount, the final amount updates and cannot be changed later.
            </AlertV2>
          </Row> */}
    </CardWithTitle>
  );
};

export default CommissionSection;
